import classNames from 'classnames'

import { EMPTY_FUNCTION } from '../../../constants/common'
import { useScreen } from '../../../hooks'
import { getQaSelector } from '../../../utils/common'
import { BirdviewState } from '../DashboardBirdview.constants'
import { checkIsBirdviewNormalState } from '../DashboardBirdview.utils.sections'

import {
  checkHasBirdviewCardAction,
  checkHasBirdviewCardShowAll,
  checkIsBirdviewCardFooterAction,
  checkIsBirdviewCardHeaderSkeleton,
} from './BirdviewCard.utils'
import { BirdviewCardBody } from './BirdviewCardBody'
import { BirdviewCardHeader } from './BirdviewCardHeader'
import { BirdviewCardShowAllButton } from './BirdviewCardShowAllButton'

import * as styles from './BirdviewCard.module.css'

function BirdviewCard({
  Action = null,
  Skeleton,
  TitleBefore = null,
  actionProps,
  children,
  count,
  dragHandleProps,
  hasMore,
  headerMenu = null,
  isAI,
  isHeaderLoading,
  isRefreshing,
  qaName,
  skeletonProps,
  state = BirdviewState.Normal,
  title,
  titleBeforeProps,
  onRetry = EMPTY_FUNCTION,
  onShowAll,
}) {
  const { screenWidth } = useScreen()

  const hasAction = checkHasBirdviewCardAction({ Action, state })
  const hasShowAll = checkHasBirdviewCardShowAll({ hasMore, state })
  const hasFooterAction = checkIsBirdviewCardFooterAction(screenWidth)
  const hasHeaderAction = (hasAction || hasShowAll) && !hasFooterAction
  const isHeaderSkeleton = checkIsBirdviewCardHeaderSkeleton({
    isHeaderLoading,
    state,
  })

  return (
    <section
      {...getQaSelector({ value: qaName })}
      className={classNames(styles.card, { [styles.ai]: isAI })}
    >
      <BirdviewCardHeader
        TitleBefore={TitleBefore}
        count={checkIsBirdviewNormalState(state) ? count : null}
        dragHandleProps={dragHandleProps}
        isAI={isAI}
        isLoading={isHeaderSkeleton}
        title={title}
        titleBeforeProps={titleBeforeProps}
      >
        {(hasHeaderAction || headerMenu) && !isHeaderSkeleton ? (
          <div className={styles.controls}>
            {hasHeaderAction && hasAction ? <Action {...actionProps} /> : null}
            {hasHeaderAction && hasShowAll ? (
              <BirdviewCardShowAllButton onClick={onShowAll} />
            ) : null}
            {headerMenu}
          </div>
        ) : null}
      </BirdviewCardHeader>
      <BirdviewCardBody
        Skeleton={Skeleton}
        isRefreshing={isRefreshing}
        skeletonProps={skeletonProps}
        state={state}
        onRetry={onRetry}
      >
        {children}
      </BirdviewCardBody>
      {(hasAction || hasShowAll) && hasFooterAction ? (
        <footer className={styles.footer}>
          {hasShowAll ? (
            <BirdviewCardShowAllButton onClick={onShowAll} />
          ) : null}
          {hasAction ? <Action {...actionProps} /> : null}
        </footer>
      ) : null}
    </section>
  )
}

export default BirdviewCard
